import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useGettingPlaylist = () => {
  const {
    response: playlist,
    onFetch: handleFetchPlaylist,
    loading,
  } = useFetch('playlist', Api.PLAYLIST);

  const onFetchPlaylist = (id) => handleFetchPlaylist({ pathParams: { id } });

  return {
    playlist,
    loading,
    onFetchPlaylist,
  };
};

export default useGettingPlaylist;
